import React from 'react';
import {useSeanetGenres} from "../../hooks/useSeanetGenres";
import OverviewImageButton from "../../components/OverviewImageButton";
import {getSeanetUrl} from "../../actions/networkActions";
import OverviewImageButtonPanel from "../../components/OverviewImageButtonPanel";
import {withTheme} from "styled-components";
import FullScreenLoader from '../../components/FullScreenLoader';
import {PropTypes} from "prop-types";


function Movies(props, context) {
    const { seanetVodData: genre, loading, error } = useSeanetGenres(props.match.params.id);

    if (error) {
        return (
            <div className="margin-horizontal-9375">
                <p>{context.t("seanet_vod_fetch_error")}</p>
            </div>
        )
    }

    if(loading || !genre) {
        return <FullScreenLoader />
    }

    return (
        <div>
            <h2 className="margin-horizontal-9375">{genre.name}</h2>
            <OverviewImageButtonPanel>
                {genre.movies.map(movie =>
                    <OverviewImageButton key={movie.path}
                                         link={"/seanetvod/movie/" + movie.path}
                                         linkState={{ locales: movie.locales }}
                                         title={movie.title}
                                         thumbnail={getSeanetUrl() + "sti/" + movie.path + "/thumb/index"}
                                         heightWidthRatio={props.theme.vodMovieHeightWidthRatio || "150%"}
                    />
                )}

            </OverviewImageButtonPanel>
        </div>
    );
}

Movies.contextTypes = {
    t: PropTypes.func.isRequired
}

export default withTheme(Movies);